import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-ext";
var Popup = /** @class */ (function (_super) {
    tslib_1.__extends(Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.close = function () {
        this.$emit("update:visible", false);
    };
    tslib_1.__decorate([
        Prop({ type: Boolean, default: false }),
        tslib_1.__metadata("design:type", Boolean)
    ], Popup.prototype, "visible", void 0);
    Popup = tslib_1.__decorate([
        Component
    ], Popup);
    return Popup;
}(Vue));
export default Popup;
